<template>
  <div class="content-wrapper">
    <h2 class="page-titles">settings</h2>

    <!-- Shipping Settings Here -->
    <div class="card-holder">
      <ShippingOptions />
    </div>

    <div class="card-holder last">
      <RedemptionSettings />
    </div>
  </div>
</template>

<script>
import { layouts } from '../helpers'
import ShippingOptions from '@/components/Profile/ShippingOptions'
import RedemptionSettings from '@/components/Profile/RedemptionSettings'

export default {
  name: 'StoreSettings',
  components: { ShippingOptions, RedemptionSettings },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.card-holder {
  border: 1px solid $onyx;
  border-radius: 29px;
  padding: 2.5rem 3.5rem;
  margin-bottom: 2rem;

  &.last {
    margin-bottom: 8rem;
  }
}
</style>
